'use strict';

var callDateGet = require('../../common/internal/callDateGet');

function getHours(d) {
  return callDateGet(d, 'Hours');
}

module.exports = getHours;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/internal/getHours.js
// module id = 277
// module chunks = 0